import React from "react";
import "./Portfolio.css"

const PortfolioOne = () => (
  <div className="PortfolioMain">

	<h1>Frontend</h1>

	<p>The frontend of this website is a single page React application.
    The  <a href={"https://www.npmjs.com/package/react-router-dom/"} 
    target={"_blank"}>react-router-dom</a> package 
    is used to provide the frontend routing,
    and Bootstrap 4.0.0 Beta is used for styling.</p>

    <p>The fading carousel component and the sliding carousel component are 
    components of my own making.  The Connect panel and the Skills panel are
    both react components.  The "Connect With Me" component is used across
    all the screens of this website.</p>
  </div>
);

export default PortfolioOne;


// WEBPACK FOOTER //
// ./src/components/Portfolio/PortfolioOne.js